
const getEmployee = (employee) => {
  if (employee) {
    return {
      employeeName: `${employee.firstName} ${employee.lastName}`,
      employeeEmail: employee.email,
      employeeInternalId: employee.internalId
    }
  }
  return {}
}

const getManager = (manager) => {
  if (manager) {
    return {
      managerName: `${manager.firstName} ${manager.lastName}`,
      managerEmail: manager.email,
      managerInternalId: manager.internalId
    }
  }
  return {}
}

export default (data) => ({
  key: data.id,
  ...getEmployee(data.employee),
  ...getManager(data.managerHierarchy),
})



// WEBPACK FOOTER //
// ./src/api/campaigns/UnassignedEmailsModel.js